import { Button } from 'components/ui/Button';
import { EyeIcon } from 'components/icons/Icons';
import { ContractualizationResponseDto } from 'api/quote';

interface ContractualizationHeaderProps {
  quoteData: ContractualizationResponseDto;
  quoteIdentifier: string;
  onShowDetails: () => void;
  detailsButtonLabel: string;
}

export const ContractualizationHeader: React.FC<
  ContractualizationHeaderProps
> = ({ quoteData, quoteIdentifier, onShowDetails, detailsButtonLabel }) => {
  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-gray-900">Devis</h1>
          <div className="w-px h-8 bg-gray-300"></div>
          <div className="bg-primary/10 text-primary px-4 py-2 rounded-lg font-semibold">
            {quoteIdentifier}
          </div>
          <div className="flex pl-8 space-x-8 items-center">
            <ContractTypeInfo
              groupContractIdentifier={quoteData.groupContractIdentifier}
              isMaster={quoteData.isMaster}
            />
            <div className="w-px h-9 bg-gray-300"></div>
            <InsurerInfo productOwner={quoteData.productOwner} />
          </div>
        </div>
        <Button color="slate" onClick={onShowDetails}>
          <EyeIcon />
          {detailsButtonLabel}
        </Button>
      </div>
    </div>
  );
};

interface ContractTypeInfoProps {
  groupContractIdentifier?: string;
  isMaster: boolean;
}

const ContractTypeInfo: React.FC<ContractTypeInfoProps> = ({
  groupContractIdentifier,
  isMaster
}) => {
  if (groupContractIdentifier) {
    return (
      <div className="flex flex-col text-sm text-slate-700">
        <div>{isMaster ? 'Contrat Cadre' : 'Contrat de Groupe'}</div>
        <div className="text-sm text-primary rounded-lg font-semibold">
          {groupContractIdentifier}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col text-sm text-slate-700">
      <div>Type de contrat</div>
      <div className="text-sm text-primary rounded-lg font-semibold">
        Individuel
      </div>
    </div>
  );
};

interface InsurerInfoProps {
  productOwner: string;
}

const InsurerInfo: React.FC<InsurerInfoProps> = ({ productOwner }) => {
  if (productOwner) {
    return (
      <div className="flex flex-col text-sm text-slate-700">
        <div>Assureur</div>
        <div className="text-sm text-primary rounded-lg font-semibold">
          {productOwner}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-primary/10 text-sm text-primary px-4 py-2 rounded-lg font-semibold">
      Individuel
    </div>
  );
};
